const t = {
  name: "Laptop",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 8C13.25 8.69 12.69 9.25 12 9.25C11.31 9.25 10.75 8.69 10.75 8C10.75 7.31 11.31 6.75 12 6.75C12.69 6.75 13.25 7.31 13.25 8Z" fill="currentColor"/>
<path d="M2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V14C22 15.6569 20.6569 17 19 17H5C3.34315 17 2 15.6569 2 14V6ZM5 5C4.44772 5 4 5.44772 4 6V14C4 14.5523 4.44772 15 5 15H19C19.5523 15 20 14.5523 20 14V6C20 5.44772 19.5523 5 19 5H5Z" fill="currentColor"/>
<path d="M24 19V21H0V19H24Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Laptop
};
